import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5631cd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uuid" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Show full id")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Full Id ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.truncatedId) + " ", 1),
      _createVNode(_component_q_icon, {
        name: "visibility",
        class: "cursor-pointer",
        onClick: _withModifiers(_ctx.onOpenShowIdDialog, ["stop"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, { delay: "600" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showFull,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showFull) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "bg-white text-dark",
          style: {"width":"420px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "text-h4" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "Close",
                  class: "text-orange-7"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "Copy Id",
                  class: "text-orange-7",
                  onClick: _ctx.handleCopy
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}